/* eslint-disable no-console */
module.exports = () =>
  process.env.NODE_ENV === 'development' ? console.log : () => {};
